import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { ImportingJob, JobStatusType } from 'features/jobs/types'
import JobItem from '../JobItem'

export default function JobImportingItemUi({
  job,
  onClick,
  onCancel,
  inlineMode
}: {
  job: ImportingJob
  onClick: () => void
  onCancel: () => void
  inlineMode: boolean
}) {
  const intl = useIntl()

  const { message, tooltip } = useMemo(() => {
    switch (job.status) {
      case JobStatusType.Success:
        return {
          message: intl.formatMessage({ id: 'jobs.datasets.status.success' }),
          tooltip: intl.formatMessage({ id: 'jobs.datasets.tooltip.success' })
        }
      case JobStatusType.Failure:
        return {
          message: inlineMode
            ? intl.formatMessage({ id: 'jobs.datasets.status.failureInline' })
            : intl.formatMessage({ id: 'jobs.datasets.status.failure' }),
          tooltip: inlineMode ? '' : intl.formatMessage({ id: 'jobs.tooltip.error' })
        }
      default: // JobStatusType.Pending, JobStatusType.Running
        return {
          message: inlineMode
            ? `${intl.formatMessage({ id: 'jobs.datasets.status.runningInline' })} ${job.connection}`
            : intl.formatMessage({ id: 'jobs.datasets.status.running' })
        }
    }
  }, [job, intl, inlineMode])

  return (
    <JobItem
      status={job.status}
      name={job.name}
      message={message}
      tooltip={tooltip}
      cursorPointer={!inlineMode || job.status === JobStatusType.Success}
      disabled={!!job?.metadata?.workflows} // Disable in the case of a workflows import
      onClick={onClick}
      padded={!inlineMode}
      onCancel={onCancel}
    />
  )
}
